<mpctm-condition-info-section class="mpctm-condition-info-section--scrollable mpctm-condition-info-section--no-padding">
  <span class="section-header" condition-info-section-header>Konditionen ({{ conditionSelectionCount() }})</span>

  <mpctm-condition-graduations
    [conditionGraduations]="conditionGraduations()"
    [baseConditionName]="baseConditionName()"
    [baseCondition]="baseCondition()"
  />
</mpctm-condition-info-section>
